// Auth/user
import LoginButton from "./auth/login"
import LogoutButton from "./auth/logout"
import { useEffect } from "react";
// old
import { gapi } from "gapi-script";
import { loadClientAuth2 } from 'gapi-script';

/*
Approach 1: "gapi-script"
https://www.npmjs.com/package/gapi-script
dfines: loadAuth2, loadAuth2WithProps, loadClientAuth2

Approach 2:
Alternative approach: "react-gapi"
(not tried)
https://github.com/ph-fritsche/react-gapi i.e., https://www.npmjs.com/package/react-gapi
defines: GoogleApiProvider, MyAuthComponent, MyDriveComponent, useGoogleApi

import { GoogleApiProvider } from 'react-gapi'
import { MyDriveComponent } from './MyDriveComponent.js'
*/

const client_id = '425916914844-jd2m6rae8avaqt111e10lifcg0g0fp7v.apps.googleusercontent.com';

import { Button } from "./Button";
import { MyCamera } from "./MyCamera";
// import { Grid } from '@mui/material';
//import Grid from '@mui/material/Unstable_Grid2';
import { Grid, Paper } from '@mui/material';

import { Typography } from '@mui/material';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import Link from '@mui/material/Link';
// import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Breadcrumbs } from '@mui/material';
import { Login } from "@mui/icons-material";

global.app_global_state = {
  // Does not work
  user_id: null,
};

const breadcrumbs = [
  <Link underline="hover" key="1" color="inherit" href="/" onClick={handleClick}>
    ApiSave
  </Link>,
  <Link
    underline="hover"
    key="2"
    color="inherit"
    href="/material-ui/getting-started/installation/"
    onClick={handleClick}
  >
    YourHive
  </Link>,
  <Typography key="3" color="text.primary">
    Check 📷
  </Typography>,
];
//todo: enable typescript
function handleClick(event /*: React.MouseEvent<HTMLAnchorElement, MouseEvent>*/) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}

function log_error(error_str, e) {
  console.error('exception caught:', e);
  document.body.append(error_str);
  document.body.append('     \n     ');
}

/** User feature: Auth / login  */
function initiate_login() {

  function start_() {
    console.debug('begin: start_(): gapi=', gapi);
    console.debug('begin: start_(): gapi.client=', gapi.client);
    console.debug('begin: start_(): client_id=', client_id);
    try {
      gapi.client.init({
        client_id: client_id,
        scope: "" // if using other APIs
      });
      console.debug('after-success: start_()');
    } catch (e) {
      console.error('after-failure: start_()', e);
      const error_str = `Error during Login: OAuth gapi.client.init: \n${e}`;
      log_error(error_str, e);
    }
    console.debug('end: start_()');
  };

  const scopes = "";
  let gapiClient = loadClientAuth2(gapi, client_id, scopes);
  console.debug('gapiClient:', gapiClient);
  // aha, it's a promise: so `loadClientAuth2` provides a Promise.
  gapiClient
    .then(x => {
      console.debug('gapiClient resolved:', x);
      // why the value is undefined? (no value yielded)

      // Solution 1:
      // Probablyl we can call the `start_` directly
      // start_();

      // Solution 2:
      // or alternatively: (potentially safer but potentially slower)
      gapi.load('client:auth2', start_);

      // (Potentially-overlapping) technical debt.

      console.debug('post: gapi.load()');
    })

  // Called above instead
  // console.debug('pre: gapi.load()');
  // gapi.load('client:auth2', start_);
  // console.debug('post: gapi.load()');
}

export function App() {

  // Called after load and DOM update
  useEffect(() => {

    // User feature: Auth / login
    initiate_login();

  });

  return <div>
    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb" > {breadcrumbs}
    </Breadcrumbs>

    <LoginButton />
    <LogoutButton />

    <Typography variant="body1" component="div">
      <h1>apisave.org: Apis🐝 Save </h1>
      {/* See https://mui.com/material-ui/react-grid/#basic-grid */}
      {/* direction="column"  */}
      <Grid container spacing={2} style={{ height: "100%" }}>
        <Grid item xs={4}>
          <Paper variant="outlined">
            <Button>Sync results</Button>
          </Paper>
        </Grid>
        <Grid item xs={8}>
        </Grid>
        <Grid item xs={12 /* was 8 */}>
          <div>
            Take a photo of a hive frame:
            <Paper variant="outlined">
              <MyCamera></MyCamera>
            </Paper>
          </div>
        </Grid>
        <Grid item xs={0 /* was 4 */} style={{ height: "100%", vertical_align: "top" }} >
          {/* browse <paper> was here */}

        </Grid>
      </Grid>
      <br />
      <Typography variant="body1" component="div">
        This is a volunteering work to save bees using an app<br />
        Bee hives health check (& monitoring) app
      </Typography>
      <br />
      <Typography variant="h4" component="div" paragraph={true}>
        Version: <span>v0.0.4/2</span>, &nbsp;
        <a href="/photos">browse</a>, &nbsp;
        <a href="/frontend/pub/inspect/">inspect</a>, &nbsp;
        <a href="/frontend/pub/about-us/architecture.html">arch.</a>, &nbsp;
        <a href="/frontend/pub/about-us">about us</a>
      </Typography>
    </Typography>

    <Grid container spacing={2} style={{ height: "100%" }}>
      <Grid item xs={6}>
        <Paper variant="outlined" style={{ /*height: "100%",*/ }}>
          <p style={{ color: "grey", vertical_align: "center" }}
            onClick={() => {
              console.log("You clicked: going back to home");
              const ifram_ = document.getElementById('file_browser_iframe');
              // TODO: username
              const un = global.app_global_state.user_id ? global.app_global_state.user_id : 'sosi';
              ifram_.src = `/photos/${un}`;
              // todo: ifram=useRef() .... OnCLick=()=>{ifram.=...}   <iframe ref={ifram}>
            }}
          ><h2>Your submitted photos queue:</h2></p>
          {/* not: style={{ height: "100%" }} */}
          {/*https://mui.com/x/react-data-grid/column-spanning/ */}
          <iframe src={`/photos/${global.app_global_state.user_id ? global.app_global_state.user_id : 'sosi'}`}
            frameBorder="0"
            id="file_browser_iframe"
            style={{ height: "300px" }}
            title='Browse uploaded photos'
          >(frame error)
          </iframe>
        </Paper>
      </Grid>
      <Grid item xs={6}>
        Results

      </Grid>
    </Grid>
  </div>;
  // (2) JSX Enabled;
}
